import React, { Component } from 'react';
import { formValueSelector, reduxForm } from 'redux-form';
import { connect } from 'react-redux';
import moment from 'moment';
import PropTypes from 'prop-types';

import { ON_HAND_REPORT_TRANSACTION_DETAILS_FORM_NAME } from 'Common/FormEnum';
import {
  OnHandReportTransactionDetailsEnum,
  TransactionDetailsEnum,
} from 'Common/FieldEnum';
import {
  DATE_FORMAT_FOR_SERVER,
  DATE_FORMAT_FOR_UI,
  ReactTableWrapperColumnProperties,
} from 'Common/Constants';
import { GridEnum } from 'Common/Constants/Enumeration/GridEnum';
import * as GridPreferenceSelector from 'State/gridPreference/selectors';

import TransactionDetailsReportComponent from '../../components/TransactionDetailsReport';
import {
  getOnHandTransactionHistory,
  setFromDateMaxForTransactionDetail,
  setToDateMinForTransactionDetail,
} from '../../state/actions';
import { INITIAL_VALUES } from '../../helper/transactionDetails';
import * as OnHandTransactionReportSelector from '../../state/selectors';
import * as CommonPrintSelector from '../../../commonState/selectors';

class TransactionDetailsReport extends Component {
  static propTypes = {
    initialValues: PropTypes.object.isRequired,
    getOnHandTransactionHistory: PropTypes.func.isRequired,
    setFromDateMaxForTransactionDetail: PropTypes.func.isRequired,
    setToDateMinForTransactionDetail: PropTypes.func.isRequired,
    FromDt: PropTypes.string,
    ToDt: PropTypes.string,
    TypesValue: PropTypes.array,
    gridPreferenceLoading: PropTypes.bool.isRequired,
    gridPreferenceSubmitting: PropTypes.bool.isRequired,
    onHandTransactionDetailsItems: PropTypes.array.isRequired,
    loadingOnHandTransactionDetailsItems: PropTypes.bool.isRequired,
    selectedFifoSitesItems: PropTypes.object.isRequired,
    transactionTypesData: PropTypes.array.isRequired,
    loadingTransactionTypesData: PropTypes.bool.isRequired,
    fromDateMaxTranDetail: PropTypes.object.isRequired,
    toDateMinTranDetail: PropTypes.object.isRequired,
    onSubmit: PropTypes.func,
  };

  static defaultProps = {
    onSubmit: () => {},
    TypesValue: [],
  };

  state = {
    activeIndexes: [0],
    typesValues: [],
    columns: [
      {
        Header: 'Site',
        accessor: OnHandReportTransactionDetailsEnum.Site,
        ...ReactTableWrapperColumnProperties,
      },
      {
        Header: 'Transaction',
        accessor: OnHandReportTransactionDetailsEnum.TransactionName,
        ...ReactTableWrapperColumnProperties,
      },
      {
        Header: 'Date',
        accessor: TransactionDetailsEnum.TransactionDT,
        ...ReactTableWrapperColumnProperties,
      },
      {
        Header: 'Item',
        accessor: TransactionDetailsEnum.Item,
        ...ReactTableWrapperColumnProperties,
      },
      {
        Header: 'Purchase Qty',
        accessor: TransactionDetailsEnum.PrimaryQty,
        className: 'right-align',
        ...ReactTableWrapperColumnProperties,
      },
      {
        Header: 'Unit',
        accessor: TransactionDetailsEnum.Unit,
        ...ReactTableWrapperColumnProperties,
      },
      {
        Header: 'Purchase Price',
        accessor: TransactionDetailsEnum.PrimaryPrice,
        className: 'right-align',
        ...ReactTableWrapperColumnProperties,
      },
      {
        Header: 'Pack Qty',
        accessor: TransactionDetailsEnum.SecondaryQty,
        className: 'right-align',
        ...ReactTableWrapperColumnProperties,
      },
      {
        Header: 'Pack Unit',
        accessor: TransactionDetailsEnum.SecondaryUnit,
        ...ReactTableWrapperColumnProperties,
      },
      {
        Header: 'Sec. Price',
        accessor: TransactionDetailsEnum.SecondaryPrice,
        className: 'right-align',
        ...ReactTableWrapperColumnProperties,
      },
      {
        Header: 'Distributor',
        accessor: TransactionDetailsEnum.Vendor,
        ...ReactTableWrapperColumnProperties,
      },
      {
        resizable: false,
        width: 50,
        sortable: false,
        filterable: false,
      },
    ],
  };

  clearFilters = () => {
    const { selectedFifoSitesItems, change } = this.props;
    change(
      OnHandReportTransactionDetailsEnum.FromDt,
      INITIAL_VALUES[OnHandReportTransactionDetailsEnum.FromDt]
    );
    change(
      OnHandReportTransactionDetailsEnum.ToDt,
      INITIAL_VALUES[OnHandReportTransactionDetailsEnum.ToDt]
    );
    change(
      OnHandReportTransactionDetailsEnum.Types,
      INITIAL_VALUES[OnHandReportTransactionDetailsEnum.Types]
    );
    this.props.getOnHandTransactionHistory({
      ...selectedFifoSitesItems,
      [OnHandReportTransactionDetailsEnum.FromDt]: moment(
        INITIAL_VALUES[OnHandReportTransactionDetailsEnum.FromDt]
      ).format(DATE_FORMAT_FOR_SERVER),
      [OnHandReportTransactionDetailsEnum.ToDt]: moment(
        INITIAL_VALUES[OnHandReportTransactionDetailsEnum.ToDt]
      ).format(DATE_FORMAT_FOR_SERVER),
      [OnHandReportTransactionDetailsEnum.ShowAllDates]: false,
      [OnHandReportTransactionDetailsEnum.Types]:
        INITIAL_VALUES[OnHandReportTransactionDetailsEnum.Types],
    });
  };

  onChangeOfFromDT = (e, date) => {
    const { selectedFifoSitesItems, ToDt, TypesValue } = this.props;
    this.props.setToDateMinForTransactionDetail(
      moment(date, DATE_FORMAT_FOR_UI)
    );
    this.props.getOnHandTransactionHistory({
      ...selectedFifoSitesItems,
      [OnHandReportTransactionDetailsEnum.FromDt]: moment(date).format(
        DATE_FORMAT_FOR_SERVER
      ),
      [OnHandReportTransactionDetailsEnum.ToDt]: moment(ToDt).format(
        DATE_FORMAT_FOR_SERVER
      ),
      [OnHandReportTransactionDetailsEnum.ShowAllDates]: false,
      [OnHandReportTransactionDetailsEnum.Types]: TypesValue,
    });
  };

  onChangeOfToDT = (e, date) => {
    const { selectedFifoSitesItems, FromDt, TypesValue } = this.props;
    this.props.setFromDateMaxForTransactionDetail(
      moment(date, DATE_FORMAT_FOR_UI)
    );
    this.props.getOnHandTransactionHistory({
      ...selectedFifoSitesItems,
      [OnHandReportTransactionDetailsEnum.FromDt]: moment(FromDt).format(
        DATE_FORMAT_FOR_SERVER
      ),
      [OnHandReportTransactionDetailsEnum.ToDt]: moment(date).format(
        DATE_FORMAT_FOR_SERVER
      ),
      [OnHandReportTransactionDetailsEnum.ShowAllDates]: false,
      [OnHandReportTransactionDetailsEnum.Types]: TypesValue,
    });
  };
  handleChangeTypes = (e, selectedTypes) => {
    const { selectedFifoSitesItems, FromDt, ToDt } = this.props;
    this.props.getOnHandTransactionHistory({
      ...selectedFifoSitesItems,
      [OnHandReportTransactionDetailsEnum.FromDt]: moment(FromDt).format(
        DATE_FORMAT_FOR_SERVER
      ),
      [OnHandReportTransactionDetailsEnum.ToDt]: moment(ToDt).format(
        DATE_FORMAT_FOR_SERVER
      ),
      [OnHandReportTransactionDetailsEnum.ShowAllDates]: false,
      [OnHandReportTransactionDetailsEnum.Types]: selectedTypes,
    });
  };
  handleCollapsePanelClick = (e, titleProps) => {
    const { index } = titleProps;
    const { activeIndexes } = this.state;
    const activeIndexesClone = [...this.state.activeIndexes];
    activeIndexes.indexOf(index) !== -1
      ? activeIndexesClone.splice(activeIndexes.indexOf(index), 1)
      : activeIndexesClone.push(index);
    this.setState({ activeIndexes: activeIndexesClone });
  };

  render() {
    const {
      onHandTransactionDetailsItems,
      loadingOnHandTransactionDetailsItems,
      loadingPrint,
      transactionTypesData,
      gridPreferenceLoading,
      gridPreferenceSubmitting,
      loadingTransactionTypesData,
      fromDateMaxTranDetail,
      toDateMinTranDetail,
    } = this.props;
    return (
      <TransactionDetailsReportComponent
        handleCollapsePanelClick={this.handleCollapsePanelClick}
        activeIndexes={this.state.activeIndexes}
        clearFilters={this.clearFilters}
        columns={this.state.columns}
        onChangeOfToDT={this.onChangeOfToDT}
        onChangeOfFromDT={this.onChangeOfFromDT}
        loadingOnHandTransactionDetailsItems={
          loadingOnHandTransactionDetailsItems
        }
        onHandTransactionDetailsItems={onHandTransactionDetailsItems}
        handleChangeTypes={this.handleChangeTypes}
        loadingPrint={loadingPrint}
        transactionTypesData={transactionTypesData}
        gridPreferenceLoading={gridPreferenceLoading}
        gridPreferenceSubmitting={gridPreferenceSubmitting}
        gridName={GridEnum.INV_OnHandReport_TransactionDetails_View}
        loadingTransactionTypesData={loadingTransactionTypesData}
        fromDateMaxTranDetail={fromDateMaxTranDetail}
        toDateMinTranDetail={toDateMinTranDetail}
      />
    );
  }
}

TransactionDetailsReport = reduxForm({
  form: ON_HAND_REPORT_TRANSACTION_DETAILS_FORM_NAME,
  destroyOnUnmount: false,
  forceUnregisterOnUnmount: true,
})(TransactionDetailsReport);

const selector = formValueSelector(
  ON_HAND_REPORT_TRANSACTION_DETAILS_FORM_NAME
);
const mapStateToProps = state => {
  return {
    FromDt: selector(state, OnHandReportTransactionDetailsEnum.FromDt),
    ToDt: selector(state, OnHandReportTransactionDetailsEnum.ToDt),
    TypesValue: selector(state, OnHandReportTransactionDetailsEnum.Types),

    gridPreferenceLoading: GridPreferenceSelector.getLoading(state),
    gridPreferenceSubmitting: GridPreferenceSelector.getIsSubmitting(state),
    transactionTypesData: CommonPrintSelector.getTransactionTypesData(state),
    loadingTransactionTypesData: CommonPrintSelector.getLoadingTransactionTypesData(
      state
    ),
    onHandTransactionDetailsItems: OnHandTransactionReportSelector.getOnHandTransactionDetailsItems(
      state
    ),
    loadingOnHandTransactionDetailsItems: OnHandTransactionReportSelector.getLoadingOnHandTransactionDetailsItems(
      state
    ),
    selectedFifoSitesItems: OnHandTransactionReportSelector.getSelectedFifoSitesItems(
      state
    ),
    fromDateMaxTranDetail: OnHandTransactionReportSelector.getFromDateMaxTranDetail(
      state
    ),
    toDateMinTranDetail: OnHandTransactionReportSelector.getToDateMinTranDetail(
      state
    ),
  };
};

const mapDispatchToProps = {
  getOnHandTransactionHistory,
  setFromDateMaxForTransactionDetail,
  setToDateMinForTransactionDetail,
};

export const TransactionDetailsReportContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(TransactionDetailsReport);



// WEBPACK FOOTER //
// ./src/pages/reports/inventory/onhandreport/containers/transactiondetails/TransactionDetailsReport.js